import { render, staticRenderFns } from "./ExternalShortcutWebpart.vue?vue&type=template&id=0474bb30&scoped=true"
import script from "./ExternalShortcutWebpart.ts?vue&type=script&lang=ts&external"
export * from "./ExternalShortcutWebpart.ts?vue&type=script&lang=ts&external"
import style0 from "./ExternalShortcutWebpart.vue?vue&type=style&index=0&id=0474bb30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0474bb30",
  null
  
)

export default component.exports